// 核心
import React from 'react';
import classnames from 'classnames';
//
import Enhance from '../core/enhance';
import Component from '../core/component'
import Form from "../mobile/form";


/**
 *
 */
class Page extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    /**
     *
     * @return {*}
     */
    render() {
        let fix = this.fix;
        // let elem = (fix && fix.elem) || <div/>;
        // console.log(elem)
        // return React.cloneElement(elem, {
        //         className: classnames(['c-page page page-current', this.props.className, elem.props.className])
        //     },
        //     <React.Fragment>
        //         {this.renderTop(fix)}
        //         {this.renderTop2(fix)}
        //         {this.renderBottom(fix)}
        //         {this.renderBottom2(fix)}
        //         {this.renderContent(fix)}
        //         {this.renderContent2(fix)}
        //     </React.Fragment>);


        let Elem = this.props.action ? Form : 'div';
        let elem = (fix && fix.elem) || <React.Fragment></React.Fragment>;
        return (
            <div {...this.props}
                 className={classnames(['c-page page page-current', this.props.className])}>
                {React.cloneElement(elem, {}, <React.Fragment>
                    {this.renderTop(fix)}
                    {this.renderTop2(fix)}
                    {this.renderBottom(fix)}
                    {this.renderBottom2(fix)}
                    {this.renderContent(fix)}
                    {this.renderContent2(fix)}
                </React.Fragment>)}
            </div>
        );
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderTop(fix) {
        if (fix && fix.top != null) {
            return (
                <header className="c-page-top bar bar-nav">
                    {fix.top}
                </header>
            );
        }
        return null;
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderTop2(fix) {
        if (fix && fix.top2 != null) {
            return (
                <header className="c-page-top2 bar bar-header-secondary">
                    {fix.top2}
                </header>
            );
        }
        return null;
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderContent(fix) {
        if (fix && fix.content != null) {
            return (
                <div className="c-page-content content">
                    {fix.content}
                </div>
            );
        }
        return null;
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderContent2(fix) {
        if (fix && fix.content2 != null) {
            return (
                <div style={{display: 'none'}}>
                    {fix.content2}
                </div>
            );
        }
        return null;
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderBottom(fix) {
        if (fix && fix.bottom != null) {
            return (
                <nav className="c-page-bottom bar bar-footer bar-tab">
                    {fix.bottom}
                </nav>
            );
        }
        return null;
    }

    /**
     *
     * @param fix
     * @return {*}
     */
    renderBottom2(fix) {
        if (fix && fix.bottom2 != null) {
            return (
                <nav className="c-page-bottom2 bar bar-footer-secondary">
                    {fix.bottom2}
                </nav>
            );
        }
        return null;
    }
}

Page.displayName = "Page"
export default Page;
